import React, { useState, useEffect } from 'react';
import { WifiIcon, ServerIcon, LogOut } from 'lucide-react';

function ResponsiveHeader() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle responsive design
  useEffect(() => {
    const checkMobileView = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener
    window.addEventListener('resize', checkMobileView);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobileView);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    window.location.href = "/"; // Redirect to login page
  };

  // Mobile view with icons only
  const MobileHeader = () => (
    <header className="bg-white shadow-sm flex justify-between items-center p-4 sticky top-0 z-10 w-full">
      <img
        src="/Assets/olivee.png"
        alt="olivee Logo"
        className="h-8"
      />

      <div className="flex items-center space-x-4">
        <WifiIcon
          size={20}
          className="text-green-500"
          title="Online Status"
        />
        <ServerIcon
          size={20}
          className="text-blue-500"
          title="Machine Status"
        />
        <img
          src="/Assets/man-user.svg"
          alt="User Avatar"
          className="w-8 h-8 rounded-full border-2 border-teal-500 cursor-pointer"
          onClick={handleLogout}
        />
      </div>
    </header>
  );

  // Full desktop view
  const DesktopHeader = () => (
    <header className="bg-white shadow-sm sticky top-0 z-10 w-full">
      <div className="flex flex-col">
        <div className="w-full flex justify-between items-center px-4 py-4">
          <div className="flex items-center space-x-2 flex-shrink-0">
            <div className="flex flex-col items-start ms-4">
              <img
                src="/Assets/olivee.png"
                alt="olivee Logo"
                className="max-h-14 w-auto object-contain"
              />
              <div className="text-xs text-gray-500 mt-1">Intelligent bio-manufacturing and energy analytics</div>
            </div>
          </div>

          <div className="flex items-center space-x-6 flex-shrink-0">
            {/* Status Indicators */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <WifiIcon
                  size={20}
                  className="text-green-500"
                  title="Online Status"
                />
                <span className="text-sm font-medium text-green-600">Online</span>
              </div>

              <div className="flex items-center space-x-2">
                <ServerIcon
                  size={20}
                  className="text-blue-500"
                  title="Machine Status"
                />
                <span className="text-sm font-medium text-blue-600">Running</span>
              </div>
            </div>

            {/* User Profile */}
            <div className="flex items-center space-x-3">
              <div className="font-medium text-sm text-right">
                <div>User</div>
                <div className="text-xs text-gray-500">Administrator</div>
              </div>
              <div className="relative group">
                <img
                  src="/Assets/man-user.svg"
                  alt="User Avatar"
                  className="w-10 h-10 rounded-full border-2 border-teal-500 cursor-pointer"
                />
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20 border border-gray-200 hidden group-hover:block">
                  <div className="py-1">
                    <a href="#profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">User</a>
                    <a
                      href="#logout"
                      onClick={handleLogout}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center cursor-pointer"
                    >
                      <LogOut size={16} className="mr-2 text-red-500" /> Logout
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );

  // Render appropriate header based on screen size
  return isMobile ? <MobileHeader /> : <DesktopHeader />;
}

export default ResponsiveHeader;